import { Auth } from 'aws-amplify';

export const getBearerToken = async () => {
  const authUser = await Auth.currentAuthenticatedUser();
  return authUser.getSignInUserSession().getIdToken().getJwtToken();
};
